
<template>
<a-form-model-item
    label="联系人手机"
    :colon="false"
    :prop="propStr"
    :label-col="{span: 6}"
    :wrapper-col="{span: 18}"
>
    <a-input
    :value="contactPhone"
    :max-length="phone.MAX_LENGTH"
    placeholder="请输入"
    @change="onChange" />
</a-form-model-item>
</template>

<script>
import FormValidator from '@/constants/formValidator'
import minix from './minix'

export default {
    mixins: [minix],
    model: {
        prop: 'contactPhone',
        event: 'change'
    },
    props: {
        contactPhone: {
            type: String,
            required: true
        },
        propName: {
            type: String,
            default: 'contactPhone'
        },
    },
    data () {
        return {
            phone: FormValidator.Phone
        }
    },
    methods: {
        onChange({target}) {
            this.$emit('change', target.value)
        }
    },
}
</script>
